import axiosInstance from "./axiosInstance";

const logServices = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/logs/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAllLogs: async () => {
        try {
            const response = await axiosInstance.get('/logs/all');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    }
}

export default logServices;